// Cooking.js
import React from 'react';

const Cooking = () => {
  return (
    <div
      id="cooking"
      style={{
        padding: '5rem 2rem',
        background: '#FDF5E8',
        color: '#2C1F14',
      }}
    >
      {/* Header */}
      <div style={{ textAlign: 'center', marginBottom: '1rem' }}>
        <p style={{ color: '#B5624A', fontSize: '0.9rem', letterSpacing: '0.2em', fontWeight: 700, textTransform: 'uppercase', margin: '0 0 0.75rem' }}>
          Small-batch · Made from scratch · Made with love
        </p>
        <h2
          style={{
            fontSize: 'clamp(2rem, 5vw, 3rem)',
            fontWeight: 800,
            margin: '0 0 1rem',
            background: 'linear-gradient(135deg, #8B4513 0%, #B5624A 100%)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            backgroundClip: 'text',
          }}
        >
          Pāka Bakehouse
        </h2>
        <p
          style={{
            maxWidth: 600,
            margin: '0 auto 2.5rem',
            color: '#6B5444',
            fontSize: '1.05rem',
            lineHeight: 1.75,
          }}
        >
          Outside of code, I run{' '}
          <a
            href="https://pakabakehouse.com"
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: '#B5624A', textDecoration: 'none', fontWeight: 600 }}
          >
            Pāka Bakehouse
          </a>{' '}
          — small-batch baked goods inspired by my grandmother Ajji's chaotic,
          aromatic kitchen back in India. "Pāka" is a Kannada word for that
          moment in sweets when everything just comes together. You can't rush
          it; you learn the feel of it.
        </p>
      </div>

      {/* CTA */}
      <div style={{ textAlign: 'center' }}>
        <a
          href="https://pakabakehouse.com"
          target="_blank"
          rel="noopener noreferrer"
          style={{
            display: 'inline-block',
            padding: '0.9rem 2.5rem',
            background: 'linear-gradient(135deg, #B5624A 0%, #C87B5E 100%)',
            color: '#fff',
            fontWeight: 800,
            fontSize: '1rem',
            borderRadius: '2rem',
            textDecoration: 'none',
            letterSpacing: '0.05em',
          }}
        >
          Visit Pāka Bakehouse →
        </a>
      </div>
    </div>
  );
};

export default Cooking;
